import Column from '@/components/nav/dropdown/column';
import Content from '@/components/nav/dropdown/content';
import ContentCard from '@/components/nav/dropdown/content-card';
import Link from '@/components/nav/dropdown/link';
import Dropdown from '@/components/nav/dropdown';
import {
  Loader,
  Paper,
  Structure,
  Cart,
  Globe,
  Star,
} from '@/components/nav/content/icons';

export function Solutions({ isDesktop }: { isDesktop: boolean }) {
  return (
    <Dropdown>
      <Column label="Use Cases">
        <Link
          href="/use-cases/content-federation"
          title="Content Federation"
          subTitle="Unify your entire stack"
          icon={Loader}
        />
        <Link
          href="/use-cases/application-content"
          title="Application Content"
          subTitle="Ship ambitious products"
          icon={Paper}
        />
        <Link
          href="/use-cases/structured-content"
          title="Structured Content"
          subTitle="Reusable content, API-first"
          icon={Structure}
        />
      </Column>
      <Column
        cta={{
          href: `/use-cases`,
          title: `View all Use Cases`,
        }}
      >
        <Link
          href="/use-cases/agile-ecommerce"
          title="eCommerce"
          subTitle="Focus on selling"
          icon={Cart}
        />
        <Link
          href="/use-cases/portals"
          title="Portals"
          subTitle="Critical information delivered"
          icon={Globe}
        />
        <Link
          href="/use-cases/marketing-websites-and-seo"
          title="Modern Websites"
          subTitle="Build modern experiences"
          icon={Star}
        />
      </Column>
      {isDesktop && (
        <Content
          cta={{
            href: `/case-studies`,
            title: `Read Customer Success Stories`,
          }}
        >
          <ContentCard
            href="/case-studies/telenor-case-study"
            label="Case Study"
            image={{
              src: `/images/nav/telenor.svg`,
              blurDataURL: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJ0lEQVQImWNgEPBh4PdikAoFIQbJ4Lb//xnCZ4CEQDKaaQxK8UAGAI8xB5T+CWFyAAAAAElFTkSuQmCC`,
            }}
            title="GraphCMS and Telenor"
          />
          <ContentCard
            href="/case-studies/2u-case-study"
            label="Case Study"
            image={{
              src: `/images/nav/2u.svg`,
              blurDataURL: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVQImWNgkC0BIZUaBoUKBgaGhJRt/4/+/88gkcfAIF3EoNnEYNwFlAcAxcQKo5C6D8QAAAAASUVORK5CYII=`,
            }}
            title="GraphCMS and 2U"
          />
        </Content>
      )}
    </Dropdown>
  );
}
